<script lang="ts" setup>
import type { ICellRendererParams, ITooltipParams } from 'ag-grid-community';
import type { PropType} from 'vue';
import { computed } from 'vue';
import type { Employment } from '@sysarb/sysarb-types/services/v1/employment';

type ExtendedParams = ICellRendererParams & {
    tooltipValueGetter: (params: ITooltipParams) => string;
};

const props = defineProps({
    params: {
        type: Object as PropType<ExtendedParams>,
        required: true
    }
});

const paramsData = computed(() => props.params.value.slice(1));
const employmentPosition = computed(() => props.params.data?.employments.map((x: Employment) => x.position).slice(1));

</script>

<template>
    <div v-if="paramsData.length > 0" class="sy-custom-tooltip sy-bg-white">
        <p v-if="employmentPosition.length > 0" class="sy-type-bold padding-3 sy-border-bottom">{{ $t('components.baseRegistry.otherActiveEmployments') }}</p>
        <div class="flex-container padding-3 sy-spacer-x-6">
            <div v-if="employmentPosition.length > 0" class="sy-spacer-y-2">
                <p v-for="(position, index) in employmentPosition" :key="index" class="sy-no-wrap">{{ position }}</p>
            </div>
            <div class="sy-spacer-y-2">
                <p v-for="(value, index) in paramsData" :key="index" class="flex-container sy-type-bold sy-no-wrap">{{ value ? value : $t('components.baseRegistry.noValueSpecified') }}</p>
            </div>
        </div>
    </div>
    <div v-else class="hide"></div>
</template>

<style lang="scss" scoped>
.sy-custom-tooltip {
  box-shadow: rgba(var(--sy-black-rgb), .1) 0 3px 10px 0;
}
</style>
